var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "simulator" } },
    [
      _c("header-signature", { attrs: { text: _vm.messages.title } }),
      _vm._v(" "),
      !_vm.selectedVariationLabel
        ? _c("div", { staticClass: "d-md-none pb-1" }, [
            _c("div", { staticClass: "lead" }, [
              _c("strong", {
                domProps: { innerHTML: _vm._s(_vm.incentiveMessageMobile) },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "simulator-block-border" }, [
        _c("div", { staticClass: "row px-1" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-6 px-0 pb-1 simulator-block-separator",
            },
            [
              _c("ob1-message-alerte", {
                attrs: {
                  title: _vm.messages.subtitle,
                  type: "info",
                  "is-simple-alerte": true,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-1 ps-md-1 pe-md-2" },
                [
                  _c("ob1-select-field", {
                    attrs: {
                      id: "variation-selector",
                      elements: _vm.variationLabels,
                      "place-holder": _vm.messages.select,
                    },
                    on: { input: _vm.onInput },
                    model: {
                      value: _vm.selectedVariationLabel,
                      callback: function ($$v) {
                        _vm.selectedVariationLabel = $$v
                      },
                      expression: "selectedVariationLabel",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.selectedVariationLabel
            ? _c(
                "div",
                { staticClass: "col-md-6 d-none d-md-block pt-2 ps-2 pe-1" },
                [
                  _c("div", { staticClass: "lead" }, [
                    _c("strong", {
                      domProps: { innerHTML: _vm._s(_vm.messages.incentive) },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]
              )
            : _c(
                "div",
                { staticClass: "col-md-6 px-md-2 pt-md-2 pb-md-1" },
                [
                  _c("hr", {
                    staticClass: "separator d-md-none mb-1 separator--gray4",
                  }),
                  _vm._v(" "),
                  _c("variation-detail", {
                    attrs: {
                      "next-url": _vm.selectedVariation.nextUrl,
                      label: _vm.optionLabel,
                      "banner-label": _vm.selectedVariation.banner,
                      "price-block": _vm.selectedVariation.priceBlockDTO,
                      "button-label": _vm.selectedVariation.buttonLabel,
                      attributes: _vm.selectedVariation.attributes,
                      "button-track-zone": "assurance_selectionnee",
                      "button-track-nom": "ajouter_cette_assurance",
                      "button-track-cible": _vm.selectedVarationTrackCible,
                      "details-popin": _vm.selectedVariation.detailsPopin,
                    },
                  }),
                  _vm._v(" "),
                  _vm.selectedVariation.detailsPopin
                    ? _c("variation-details-popin", {
                        attrs: {
                          dto: _vm.selectedVariation.detailsPopin,
                          "button-track-cible": _vm.selectedVarationTrackCible,
                          "button-track-zone": "assurance_selectionnee",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font-size-28 text-primary" }, [
      _c("span", {
        staticClass: "alert-icon icon-goto-gauche",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }